import React from 'react';
import {Link} from 'react-router-dom';
import Social from './Social';

const Footer = () => (
    <footer className="footer turnBlack flexRow">
        <div className="footer-cta flexColumn flexStart alignStart width-4">
            <p className="tinyFont turnBlack">Start a Project:</p>
            <a className="tinyFont turnBlack">thegoat@candidgoat.com</a>
            <p className="tinyFont turnBlack">&copy; Candid Goat Productions {(new Date().getFullYear())}</p>
        </div>
        <div className="footer-nav flexColumn flexStart alignStart width-4">
            <Link to="/" className="footer-navLink tinyFont turnBlack">Home</Link>
            <Link to="/About" className="footer-navLink tinyFont turnBlack">About</Link>
            <Link to="/Services" className="footer-navLink tinyFont turnBlack">Services</Link>
            <Link to="/Privacy" className="footer-navLink tinyFont turnBlack">Privacy</Link>
        </div>
        <div className="footer-contact flexColumn flexEnd alignEnd width-4">
            {/* <p>Sign up to receive new content.</p>
            <form className="flexRow emailSignUpWrapper" action="">
                <input type="email" name="email" id="emailSignUp" className="tinyFont turnBlack" />
                <input type="submit" value="OK" id="emailSubmit" className="tinyFont" />
            </form> */}
            <p className="tinyFont turnBlack">Proud Residents of Winter Park, FL</p>
            <p className="tinyFont turnBlack">Connect with us on Social Media:</p>
            <Social/>
        </div>
    </footer>
)

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js